import { render } from "./categoriesComponent.vue?vue&type=template&id=d98ed444&scoped=true"
import script from "./categoriesComponent.vue?vue&type=script&lang=js"
export * from "./categoriesComponent.vue?vue&type=script&lang=js"

import "./categoriesComponent.vue?vue&type=style&index=0&id=d98ed444&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d98ed444"]])

export default __exports__